import curd from '../curd'

const BASE_PATH = '/org'

export default curd(BASE_PATH)



// WEBPACK FOOTER //
// ./src/apis/modules/Org.js